// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-slide-toggle {
  margin: 0;
}
.modal-body .form-row {
  margin: 8px 0;
}
.modal-header {
  background-color: #0f1a35;
  color: white !important;
}
.modal-header .modal-title {
  font-size: 20px !important;
  font-weight: 600;
}
.modal-header .close {
  color: red;
  text-shadow: none;
  opacity: 1;
  font-size: 26px;
  padding: 0 !important;
  margin: 0 !important;
  box-shadow: none;
  background: transparent;
  right: 20px;
  position: absolute;
}
.modal-footer {
  padding: 2px !important;
}
.bigAssModal .modal-dialog {
  max-width: 90% !important;
}
.grid.screenings {
  grid-template-columns: repeat(9, auto);
}
.full-grid-row {
  background-color: rgba(108, 117, 125, 0.5);
  grid-column-start: 1;
  grid-column-end: 10;
}
.form-check {
  padding-left: 4% !important;
}
`, "",{"version":3,"sources":["webpack://./src/assets/ngb-modals.less","webpack://./src/app/packages-module/client-package-edit/client-package-edit.component.less"],"names":[],"mappings":"AAEA;EACE,SAAA;ACDF;ADGA;EACI,aAAA;ACDJ;ADIA;EACI,yBAAA;EACA,uBAAA;ACFJ;ADAA;EAKO,0BAAA;EACA,gBAAA;ACFP;ADJA;EASO,UAAA;EACC,iBAAA;EACA,UAAA;EACD,eAAA;EACA,qBAAA;EACA,oBAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;ACFP;ADMA;EACI,uBAAA;ACJJ;ADOA;EACI,yBAAA;ACLJ;AA3BA;EACI,sCAAA;AA6BJ;AA1BA;EACI,0CAAA;EACA,oBAAA;EACA,mBAAA;AA4BJ;AAzBA;EACI,2BAAA;AA2BJ","sourcesContent":["@import (reference) url('../styles.less');\n\nmat-slide-toggle {\n  margin: 0;\n}\n.modal-body .form-row{\n    margin: 8px 0;\n}\n\n.modal-header{\n    background-color: #0f1a35;\n    color: white !important;\n    \n    .modal-title{\n       font-size: 20px !important;\n       font-weight: 600;\n    };\n    .close{\n       color: red;\n        text-shadow: none;\n        opacity: 1;\n       font-size: 26px;\n       padding: 0 !important;\n       margin : 0 !important;\n       box-shadow: none;\n       background: transparent;\n       right: 20px;\n       position: absolute;\n    }\n}\n\n.modal-footer{\n    padding: 2px !important;\n}\n\n.bigAssModal .modal-dialog{\n    max-width: 90% !important;\n}","@import url('../../../assets/ngb-modals.less');\n\n@rowCount : 9;\n\n.grid.screenings {\n    grid-template-columns: repeat(@rowCount, auto);\n}\n\n.full-grid-row {\n    background-color: rgba(108,117,125,.5);\n    grid-column-start: 1;\n    grid-column-end: @rowCount + 1;\n}\n\n.form-check{\n    padding-left: 4% !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
